import ScriptItem from "./ScriptItem";
import VideoItem from "./VideoItem";
import "./index.scss";
import { useAppSelector } from "@hooks/redux";

export default () => {
  const { downloadingItems } = useAppSelector((state) => state.globalVideoReducer);

  return (
    <div className="Layout-VideoDownloading">
      <div className="items">
        {downloadingItems.map((downloadItem) => {
          if (downloadItem.finish === false) {
            if (downloadItem.type === "video") {
              return <VideoItem key={downloadItem.videoId} downloadItem={downloadItem}></VideoItem>;
            }
            if (downloadItem.type === "script") {
              return <ScriptItem key={downloadItem.videoId} downloadItem={downloadItem}></ScriptItem>;
            }
          }
          return true;
        })}
      </div>
    </div>
  );
};
